import { z } from "zod";

export const emailSchema = z.string().email();

export const loginSchema = z.object({
  email: z.string({ message: "Renseignez votre email" }),
  password: z.string({ message: "Renseignez votre mot de passe" }),
});

export type LoginForm = z.infer<typeof loginSchema>;

export const loginDefaultValues: LoginForm = {
  email: "",
  password: "",
};

export const forgotPasswordSchema = z.object({
  email: z.string({ message: "Renseignez une adresse email" }),
});

export type ForgotPasswordForm = z.infer<typeof forgotPasswordSchema>;

export const forgotPasswordDefaultValues: ForgotPasswordForm = {
  email: "",
};

export const passwordSchema = z
  .string({ message: "Renseignez votre mot de passe" })
  .min(8, "Le mot de passe doit avoir au moins 8 caractères")
  .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>-_])/, {
    message:
      'Votre mot de passe doit contenir au moins une majuscule, une minuscule, un chiffre et un caractère spécial (!@#$%^&*(),.?"{}:|<>-_)',
  });

export const registerSchema = z.object({
  lastName: z.string({ message: "Renseignez votre nom" }),
  firstName: z.string({ message: "Renseignez votre prénom" }),
  RPPS: z
    .number({ message: "Renseignez votre numéro RPPS" })
    .int()
    .gte(10000000000, {
      message: "Votre numéro RPPS doit contenir 11 chiffres.",
    })
    .lte(99999999999, {
      message: "Votre numéro RPPS doit contenir 11 chiffres.",
    })
    .nullable(),
  email: z.string({ message: "Renseignez votre adresse mail" }),
  password: z.string({ message: "Renseignez votre mot de passe" }),
});

export type RegisterForm = z.infer<typeof registerSchema>;

export const registerDefaultValues: RegisterForm = {
  lastName: "",
  firstName: "",
  RPPS: null,
  email: "",
  password: "",
};

export const resetPasswordSchema = z
  .object({
    password: z.string({ message: "Renseignez votre mot de passe" }),
    passwordConfirmation: z.string({
      message:
        "Renseignez votre mot de passe une seconde fois pour le confirmer",
    }),
    code: z.string().optional(),
    email: z.string().email().optional(),
  })
  .refine(
    ({ password, passwordConfirmation }) => password === passwordConfirmation,
    {
      message: "Les mots de passe ne correspondent pas",
      path: ["passwordConfirmation"],
    }
  );

export type ResetPasswordForm = z.infer<typeof resetPasswordSchema>;

export const resetPasswordDefaultValues: ResetPasswordForm = {
  password: "",
  passwordConfirmation: "",
  code: undefined,
  email: undefined,
};
